// react-frontend/src/admin/auth/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ requiredRole }) => {
  const token = localStorage.getItem('adminToken');
  
  // If no token exists, redirect to login
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  try {
    // Decode token without checking expiration
    const decoded = jwtDecode(token);
    
    // Verify role if required (e.g., for role-based routes)
    if (requiredRole && decoded.role !== requiredRole) {
      return <Navigate to="/admin/unauthorized" replace />;
    }

    // Token is valid - render the protected route
    return <Outlet />;
    
  } catch (error) {
    // Handle malformed/invalid tokens
    console.error('Token validation error:', error);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    return <Navigate to="/admin/login" replace />;
  }
};

export default PrivateRoute;